var _excluded = ["error", "disabled", "className", "name", "valid", "width"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import BackgroundProvider from "../BackgroundProvider";
import classnames from 'classnames';
import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import StyledTextInput, { StyledTextInputCss } from "./styled";
var TextInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    customClassName = _ref.className,
    name = _ref.name,
    _ref$valid = _ref.valid,
    valid = _ref$valid === void 0 ? false : _ref$valid,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'default' : _ref$width,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme() || {};
  var className = classnames('csl-text-input', customClassName, {
    'csl-text-input--valid': !disabled && valid
  });
  return /*#__PURE__*/React.createElement(BackgroundProvider, {
    value: {
      cssValue: theme.color_input_background_default
    }
  }, /*#__PURE__*/React.createElement(StyledTextInput, _extends({
    $valid: valid,
    $width: width
  }, rest, {
    "aria-invalid": error,
    className: className,
    disabled: disabled,
    id: name,
    name: name,
    ref: ref
  })));
});
TextInput.displayName = 'TextInput';
export default TextInput;
export { StyledTextInputCss };